import { render, staticRenderFns } from "./DisputedCallsBreakdown.vue?vue&type=template&id=22dc401b&scoped=true"
import script from "./DisputedCallsBreakdown.vue?vue&type=script&lang=js"
export * from "./DisputedCallsBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DisputedCallsBreakdown.vue?vue&type=style&index=0&id=22dc401b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc401b",
  null
  
)

export default component.exports